import React, { useEffect, useState } from "react";
import axios from "axios";
import { useReducedMotion } from "framer-motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Slow vertical marquee of communities Dan has played, faded out at both ends.
 * Duplicated once so the loop is seamless; pauses on hover.
 */
export default function VenueMarquee() {
  const [venues, setVenues] = useState([]);
  const still = useReducedMotion();

  useEffect(() => {
    let alive = true;
    axios
      .get(`${API}/venues`)
      .then(({ data }) => {
        if (alive) setVenues(data.venues || []);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  if (venues.length === 0)
    return <div aria-hidden="true" style={{ height: "clamp(320px, 46vh, 460px)" }} />;

  const loop = [...venues, ...venues];
  const duration = Math.max(30, venues.length * 2.2);

  return (
    <div className="relative" data-testid="venue-marquee">
      <p className="text-[10px] uppercase tracking-[0.32em] mb-4 text-center" style={{ color: "#F2D589" }}>
        Where Dan has played
      </p>
      <div
        className="venue-marquee relative overflow-hidden"
        style={{
          height: "clamp(320px, 46vh, 460px)",
          maskImage:
            "linear-gradient(to bottom, transparent 0%, #000 16%, #000 84%, transparent 100%)",
          WebkitMaskImage:
            "linear-gradient(to bottom, transparent 0%, #000 16%, #000 84%, transparent 100%)",
        }}
      >
        <ul
          className="venue-marquee-track flex flex-col items-center gap-4 text-center"
          style={still ? undefined : { animationDuration: `${duration}s` }}
        >
          {loop.map((name, i) => (
            <li
              key={`${name}-${i}`}
              className="text-base sm:text-lg leading-snug"
              style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontWeight: 500,
                color: i % 4 === 0 ? "#F2D589" : "rgba(245,239,227,0.72)",
                letterSpacing: "0.01em",
              }}
            >
              {name}
            </li>
          ))}
        </ul>
      </div>

      <style>{`
        .venue-marquee-track {
          animation-name: venue-scroll;
          animation-timing-function: linear;
          animation-iteration-count: infinite;
          will-change: transform;
        }
        .venue-marquee:hover .venue-marquee-track { animation-play-state: paused; }
        @keyframes venue-scroll {
          from { transform: translateY(0); }
          to { transform: translateY(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          .venue-marquee-track { animation: none; }
        }
      `}</style>
    </div>
  );
}
